module.exports = __webpack_public_path__ + "static/media/bell2.5f03fda2.svg";